const Translation = (i18n) => {
    const domLanguage = document.documentElement.lang;

    const translations = {
        yes: {
            de: 'Ja',
            en: 'Yes'
        },
        no: {
            de: 'Nein',
            en: 'No'
        },
        contact: {
            de: 'Kontakt',
            en: 'Contact'
        },
        terms: {
            de: 'AGB',
            en: 'Terms'
        },
        privacy: {
            de: 'Datenschutz',
            en: 'Data privacy'
        },
        answerInfoText1: {
            de: 'Bitte wähle die Antwortmöglichkeiten, welche am besten zutreffen.',
            en: 'Please choose the answer options that apply best.'
        },
        answerInfoText2: {
            de: 'Bitte wähle die Antwortmöglichkeit, welche am besten zutrifft.',
            en: 'Please choose the answer that applies best.'
        },
        next: {
            de: 'Weiter',
            en: 'Next'
        },
        sure: {
            de: 'Bist du sicher?',
            en: 'Are you sure?'
        },
        imSure: {
            de: 'Ja, ich bin sicher!',
            en: 'Yes I am sure!'
        },
        complete: {
            de: 'Fragebogen abschließen',
            en: 'Complete the questionnaire'
        },
        question: {
            de: 'Frage',
            en: 'Question'
        },
        notAvailable: {
            de: 'Dieser Fragebogen ist nicht mehr verfügbar!',
            en: 'This questionnaire is no longer available!'
        },
        moreAbout: {
            de: 'Mehr über moodmap',
            en: 'More about moodmap'
        },
        start: {
            de: 'Fragebogen starten',
            en: 'Start questionnaire'
        },
        thankYou: {
            de: 'Danke',
            en: 'Thanks'
        },
        isFinish: {
            de: 'Wunderbar! Fragebogen ist fertig.',
            en: 'Wonderful! Questionnaire is ready.'
        },
        endInfo1: {
            de: 'Dein Ergebnis sollte jeden Moment per Mail kommen.',
            en: 'Your result should be in the mail any moment.'
        },
        endInfo2: {
            de: 'Keine Angst, deine Antworten auf einzelne Fragen werden nicht mitgeteilt. moodmap ist ein nicht wertendes Tool, und es gibt kein schlechtes Ergebnis.',
            en: "Don't worry, your answers to individual questions will not be shared. moodmap is a non-judgmental tool and there is no such thing as a bad score."
        },
        endInfo3: {
            de: 'Bitte überprüfe auch deinen Spamordner.',
            en: "Please also check your spam folder."
        },
        isRegistered: {
            de: 'Bitte gib deine Daten ein um fortzufahren ...',
            en: 'Please enter your details to continue...'
        },
        isThatYou: {
            de: 'Bist das du?',
            en: 'Is that you?'
        },
        unless: {
            de: 'Wenn nicht, gib bitte deinen Namen und deine E-Mail Adresse ein.',
            en: 'If not, please enter your name and email address.'
        },
        correctMail: {
            de: 'Bitte gib eine korrekte E-Mail Adresse ein!',
            en: 'Please enter a correct email address!'
        },
        yourNamePlease: {
            de: 'Bitte gib deinen Namen ein',
            en: 'Please enter your name'
        },
        yourMailPlease: {
            de: 'Bitte gib deine E-Mail Adresse ein',
            en: 'Please enter your email address'
        },
        continue: {
            de: 'Fortfahren',
            en: 'Continue'
        },
        yesIam: {
            de: 'Ja, das bin ich ...',
            en: 'Yes I am ...'
        },
        questionnaireHeader: {
            de: 'Fragebogen',
            en: 'Questionnaire'
        },
        questionnaireSubHeader: {
            de: 'Eine kurze Erklärung zum Ablauf',
            en: 'A brief explanation of the process'
        }
    };

    for(let i in translations) {
        if(i === i18n.i18n) {
            return translations[i][domLanguage];
        }
    }

}

export default Translation;
